define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.MDpsDomain = void 0;
    class MDpsDomain {
        static initialise() {
            if (!this.isInitialised) {
                this.isInitialised = true;
                this.values = [
                    { key: MDpsDomain.PBlueGrassesEGForestBothriochloaSpp, value: "P - Blue Grasses (e.g. Forest) (Bothriochloa spp)" },
                    { key: MDpsDomain.PBlueGrassesEGQueenslandDichanthiumSpp, value: "P - Blue Grasses (e.g. Queensland) (Dichanthium spp)" },
                    { key: MDpsDomain.PBrowntopEulaliaSpp, value: "P - Browntop (Eulalia spp)" },
                    { key: MDpsDomain.PBuffelGrassCenchrusCiliaris, value: "P - Buffel Grass (Cenchrus ciliaris)" },
                    { key: MDpsDomain.PChlorisSppLargeEGRhodesChlorisSppLargeEGRhodes, value: "P - Chloris spp (Large e.g. Rhodes) (Chloris spp (Large e.g. Rhodes))" },
                    { key: MDpsDomain.PMitchellGrassesAstreblaSpp, value: "P - Mitchell Grasses (Astrebla spp)" },
                    { key: MDpsDomain.PMulgaMitchellThyridolepsisMitchelliana, value: "P - Mulga Mitchell (Thyridolepsis mitchelliana)" },
                    { key: MDpsDomain.PMulgaOatsMonochatherParadoxa, value: "P - Mulga Oats (Monochather paradoxa)" },
                    { key: MDpsDomain.PNativeOatKangarooGrassThemedaSppExceptGraderGrass, value: "P - Native oat, Kangaroo Grass (Themeda spp (except Grader grass))" },
                    { key: MDpsDomain.PPanicPanicumSppLargeLeaf, value: "P - Panic (Panicum spp (Large leaf))" },
                    { key: MDpsDomain.PSabiGrassUrochloaSpp, value: "P - Sabi Grass (Urochloa spp)" },
                    { key: MDpsDomain.PSpeargrassHeteropogonSpp, value: "P - Speargrass (Heteropogon spp)" },
                    { key: MDpsDomain.PSpinifexHardOrSoftTriodiaAndPlechtrachneSpp, value: "P - Spinifex (hard or soft) (Triodia and Plechtrachne spp)" },
                    { key: MDpsDomain.POtherPreferredSpecies, value: "P - other Preferred species" },
                    { key: MDpsDomain.IBarbwireGrassCymbopogonSpp, value: "I - Barbwire Grass (Cymbopogon spp)" },
                    { key: MDpsDomain.IBluebushMaireanaSpp, value: "I - Bluebush (Maireana spp)" },
                    { key: MDpsDomain.IBottleWashersEnneapogonSpp, value: "I - Bottle Washers (Enneapogon spp)" },
                    { key: MDpsDomain.ICaneGrassZygochloaParadoxa, value: "I - Cane Grass (Zygochloa paradoxa)" },
                    { key: MDpsDomain.IChlorisSmallEGWindmillGrassChlorisSmallEGWindmillGrass, value: "I - Chloris (Small e.g. Windmill grass) (Chloris (Small e.g. Windmill grass))" },
                    { key: MDpsDomain.ICouchCynodonDactylon, value: "I - Couch (Cynodon dactylon)" },
                    { key: MDpsDomain.ICupgrassesEriochloaSpp, value: "I - Cupgrasses (Eriochloa spp)" },
                    { key: MDpsDomain.IFairyGrassSporobolusSpp, value: "I - Fairy Grass (Sporobolus spp)" },
                    { key: MDpsDomain.IFingerGrassesDigitariaSpp, value: "I - Finger Grasses (Digitaria spp)" },
                    { key: MDpsDomain.IFiveMinuteGrassTripogonLoliiformis, value: "I - Five Minute Grass (Tripogon loliiformis)" },
                    { key: MDpsDomain.IGoldenBeardGrassChrysopogonFallax, value: "I - Golden Beard Grass (Chrysopogon fallax)" },
                    { key: MDpsDomain.ILoveGrassesEragrostisSpp, value: "I - Love Grasses (Eragrostis spp)" },
                    { key: MDpsDomain.IMolassesRedNatalMelinisSpp, value: "I - Molasses, Red Natal (Melinis spp)" },
                    { key: MDpsDomain.IPanicPanicumSpp, value: "I - Panic (Panicum spp)" },
                    { key: MDpsDomain.ISaltBushesAtriplexSpp, value: "I - Salt bushes (Atriplex spp)" },
                    { key: MDpsDomain.ISorghumSorghumSpp, value: "I - Sorghum (Sorghum spp)" },
                    { key: MDpsDomain.ISummerGrassPaspalidiumSpp, value: "I - Summer grass (Paspalidium spp)" },
                    { key: MDpsDomain.IWallabyGrassDanthoniaSpp, value: "I - Wallaby Grass (Danthonia spp)" },
                    { key: MDpsDomain.IWanderrieEriachneSpp, value: "I - Wanderrie (Eriachne spp)" },
                    { key: MDpsDomain.IOtherIntermediateSpecies, value: "I - other Intermediate species" },
                    { key: MDpsDomain.NBladyGrassImperataCylindrica, value: "N - Blady Grass (Imperata cylindrica)" },
                    { key: MDpsDomain.NNutGrassCyperusSpp, value: "N - Nut Grass (Cyperus spp)" },
                    { key: MDpsDomain.NReedGrassArundinellaSpp, value: "N - Reed Grass (Arundinella spp)" },
                    { key: MDpsDomain.NThatchGrassHyparrheniaSpp, value: "N - Thatch Grass (Hyparrhenia spp)" },
                    { key: MDpsDomain.NWiregrassesAristidaSpp, value: "N - Wiregrasses (Aristida spp )" },
                    { key: MDpsDomain.NOtherNonPreferredSpecies, value: "N - other Non-preferred species" },
                    { key: MDpsDomain.ABarnyardsOrMilletsEchinochloaSpp, value: "A - Barnyards or Millets (Echinochloa spp)" },
                    { key: MDpsDomain.AButtonGrassDactylocteniumRadulans, value: "A - Button Grass (Dactyloctenium radulans)" },
                    { key: MDpsDomain.AChlorisChlorisSmallEGWindmillGrass, value: "A - Chloris (Chloris (Small e.g. Windmill grass))" },
                    { key: MDpsDomain.AFairyGrassSporobolusSpp, value: "A - Fairy Grass (Sporobolus spp)" },
                    { key: MDpsDomain.AFingerRushFimbristylisSpp, value: "A - Finger Rush (Fimbristylis spp)" },
                    { key: MDpsDomain.AFireGrassSchizachrium, value: "A - Fire Grass (Schizachrium)" },
                    { key: MDpsDomain.AFlindersGrassIseilemaSpp, value: "A - Flinders Grass (Iseilema spp)" },
                    { key: MDpsDomain.AForbsBurrsChenopodsOtherNonGrassesForbsBurrsChenopodsOtherNonGrasses, value: "A - Forbs (Burrs, Chenopods, other non-grasses) (Forbs (Burrs, Chenopods, other non-grasses))" },
                    { key: MDpsDomain.ANativeCouchBrachyachneSpp, value: "A - Native Couch (Brachyachne spp)" },
                    { key: MDpsDomain.APanicPanicumSpp, value: "A - Panic (Panicum spp)" },
                    { key: MDpsDomain.ASmallBurrGrassTragusAustralianus, value: "A - Small Burr Grass (Tragus australianus)" },
                    { key: MDpsDomain.AWhiteGrassSehimaSpp, value: "A - White Grass (Sehima spp)" },
                    { key: MDpsDomain.AWindmillGrassesEnteropogonSpp, value: "A - Windmill grasses (Enteropogon spp)" },
                    { key: MDpsDomain.AOtherAnnualOrForb, value: "A - other Annual or Forb" }
                ];
                this.KeyIndex = {};
                this.KeyIndex[MDpsDomain.PBlueGrassesEGForestBothriochloaSpp] = 0;
                this.KeyIndex[MDpsDomain.PBlueGrassesEGQueenslandDichanthiumSpp] = 1;
                this.KeyIndex[MDpsDomain.PBrowntopEulaliaSpp] = 2;
                this.KeyIndex[MDpsDomain.PBuffelGrassCenchrusCiliaris] = 3;
                this.KeyIndex[MDpsDomain.PChlorisSppLargeEGRhodesChlorisSppLargeEGRhodes] = 4;
                this.KeyIndex[MDpsDomain.PMitchellGrassesAstreblaSpp] = 5;
                this.KeyIndex[MDpsDomain.PMulgaMitchellThyridolepsisMitchelliana] = 6;
                this.KeyIndex[MDpsDomain.PMulgaOatsMonochatherParadoxa] = 7;
                this.KeyIndex[MDpsDomain.PNativeOatKangarooGrassThemedaSppExceptGraderGrass] = 8;
                this.KeyIndex[MDpsDomain.PPanicPanicumSppLargeLeaf] = 9;
                this.KeyIndex[MDpsDomain.PSabiGrassUrochloaSpp] = 10;
                this.KeyIndex[MDpsDomain.PSpeargrassHeteropogonSpp] = 11;
                this.KeyIndex[MDpsDomain.PSpinifexHardOrSoftTriodiaAndPlechtrachneSpp] = 12;
                this.KeyIndex[MDpsDomain.POtherPreferredSpecies] = 13;
                this.KeyIndex[MDpsDomain.IBarbwireGrassCymbopogonSpp] = 14;
                this.KeyIndex[MDpsDomain.IBluebushMaireanaSpp] = 15;
                this.KeyIndex[MDpsDomain.IBottleWashersEnneapogonSpp] = 16;
                this.KeyIndex[MDpsDomain.ICaneGrassZygochloaParadoxa] = 17;
                this.KeyIndex[MDpsDomain.IChlorisSmallEGWindmillGrassChlorisSmallEGWindmillGrass] = 18;
                this.KeyIndex[MDpsDomain.ICouchCynodonDactylon] = 19;
                this.KeyIndex[MDpsDomain.ICupgrassesEriochloaSpp] = 20;
                this.KeyIndex[MDpsDomain.IFairyGrassSporobolusSpp] = 21;
                this.KeyIndex[MDpsDomain.IFingerGrassesDigitariaSpp] = 22;
                this.KeyIndex[MDpsDomain.IFiveMinuteGrassTripogonLoliiformis] = 23;
                this.KeyIndex[MDpsDomain.IGoldenBeardGrassChrysopogonFallax] = 24;
                this.KeyIndex[MDpsDomain.ILoveGrassesEragrostisSpp] = 25;
                this.KeyIndex[MDpsDomain.IMolassesRedNatalMelinisSpp] = 26;
                this.KeyIndex[MDpsDomain.IPanicPanicumSpp] = 27;
                this.KeyIndex[MDpsDomain.ISaltBushesAtriplexSpp] = 28;
                this.KeyIndex[MDpsDomain.ISorghumSorghumSpp] = 29;
                this.KeyIndex[MDpsDomain.ISummerGrassPaspalidiumSpp] = 30;
                this.KeyIndex[MDpsDomain.IWallabyGrassDanthoniaSpp] = 31;
                this.KeyIndex[MDpsDomain.IWanderrieEriachneSpp] = 32;
                this.KeyIndex[MDpsDomain.IOtherIntermediateSpecies] = 33;
                this.KeyIndex[MDpsDomain.NBladyGrassImperataCylindrica] = 34;
                this.KeyIndex[MDpsDomain.NNutGrassCyperusSpp] = 35;
                this.KeyIndex[MDpsDomain.NReedGrassArundinellaSpp] = 36;
                this.KeyIndex[MDpsDomain.NThatchGrassHyparrheniaSpp] = 37;
                this.KeyIndex[MDpsDomain.NWiregrassesAristidaSpp] = 38;
                this.KeyIndex[MDpsDomain.NOtherNonPreferredSpecies] = 39;
                this.KeyIndex[MDpsDomain.ABarnyardsOrMilletsEchinochloaSpp] = 40;
                this.KeyIndex[MDpsDomain.AButtonGrassDactylocteniumRadulans] = 41;
                this.KeyIndex[MDpsDomain.AChlorisChlorisSmallEGWindmillGrass] = 42;
                this.KeyIndex[MDpsDomain.AFairyGrassSporobolusSpp] = 43;
                this.KeyIndex[MDpsDomain.AFingerRushFimbristylisSpp] = 44;
                this.KeyIndex[MDpsDomain.AFireGrassSchizachrium] = 45;
                this.KeyIndex[MDpsDomain.AFlindersGrassIseilemaSpp] = 46;
                this.KeyIndex[MDpsDomain.AForbsBurrsChenopodsOtherNonGrassesForbsBurrsChenopodsOtherNonGrasses] = 47;
                this.KeyIndex[MDpsDomain.ANativeCouchBrachyachneSpp] = 48;
                this.KeyIndex[MDpsDomain.APanicPanicumSpp] = 49;
                this.KeyIndex[MDpsDomain.ASmallBurrGrassTragusAustralianus] = 50;
                this.KeyIndex[MDpsDomain.AWhiteGrassSehimaSpp] = 51;
                this.KeyIndex[MDpsDomain.AWindmillGrassesEnteropogonSpp] = 52;
                this.KeyIndex[MDpsDomain.AOtherAnnualOrForb] = 53;
                this.ValueIndex = {};
                this.ValueIndex["P - Blue Grasses (e.g. Forest) (Bothriochloa spp)"] = 0;
                this.ValueIndex["P - Blue Grasses (e.g. Queensland) (Dichanthium spp)"] = 1;
                this.ValueIndex["P - Browntop (Eulalia spp)"] = 2;
                this.ValueIndex["P - Buffel Grass (Cenchrus ciliaris)"] = 3;
                this.ValueIndex["P - Chloris spp (Large e.g. Rhodes) (Chloris spp (Large e.g. Rhodes))"] = 4;
                this.ValueIndex["P - Mitchell Grasses (Astrebla spp)"] = 5;
                this.ValueIndex["P - Mulga Mitchell (Thyridolepsis mitchelliana)"] = 6;
                this.ValueIndex["P - Mulga Oats (Monochather paradoxa)"] = 7;
                this.ValueIndex["P - Native oat, Kangaroo Grass (Themeda spp (except Grader grass))"] = 8;
                this.ValueIndex["P - Panic (Panicum spp (Large leaf))"] = 9;
                this.ValueIndex["P - Sabi Grass (Urochloa spp)"] = 10;
                this.ValueIndex["P - Speargrass (Heteropogon spp)"] = 11;
                this.ValueIndex["P - Spinifex (hard or soft) (Triodia and Plechtrachne spp)"] = 12;
                this.ValueIndex["P - other Preferred species"] = 13;
                this.ValueIndex["I - Barbwire Grass (Cymbopogon spp)"] = 14;
                this.ValueIndex["I - Bluebush (Maireana spp)"] = 15;
                this.ValueIndex["I - Bottle Washers (Enneapogon spp)"] = 16;
                this.ValueIndex["I - Cane Grass (Zygochloa paradoxa)"] = 17;
                this.ValueIndex["I - Chloris (Small e.g. Windmill grass) (Chloris (Small e.g. Windmill grass))"] = 18;
                this.ValueIndex["I - Couch (Cynodon dactylon)"] = 19;
                this.ValueIndex["I - Cupgrasses (Eriochloa spp)"] = 20;
                this.ValueIndex["I - Fairy Grass (Sporobolus spp)"] = 21;
                this.ValueIndex["I - Finger Grasses (Digitaria spp)"] = 22;
                this.ValueIndex["I - Five Minute Grass (Tripogon loliiformis)"] = 23;
                this.ValueIndex["I - Golden Beard Grass (Chrysopogon fallax)"] = 24;
                this.ValueIndex["I - Love Grasses (Eragrostis spp)"] = 25;
                this.ValueIndex["I - Molasses, Red Natal (Melinis spp)"] = 26;
                this.ValueIndex["I - Panic (Panicum spp)"] = 27;
                this.ValueIndex["I - Salt bushes (Atriplex spp)"] = 28;
                this.ValueIndex["I - Sorghum (Sorghum spp)"] = 29;
                this.ValueIndex["I - Summer grass (Paspalidium spp)"] = 30;
                this.ValueIndex["I - Wallaby Grass (Danthonia spp)"] = 31;
                this.ValueIndex["I - Wanderrie (Eriachne spp)"] = 32;
                this.ValueIndex["I - other Intermediate species"] = 33;
                this.ValueIndex["N - Blady Grass (Imperata cylindrica)"] = 34;
                this.ValueIndex["N - Nut Grass (Cyperus spp)"] = 35;
                this.ValueIndex["N - Reed Grass (Arundinella spp)"] = 36;
                this.ValueIndex["N - Thatch Grass (Hyparrhenia spp)"] = 37;
                this.ValueIndex["N - Wiregrasses (Aristida spp )"] = 38;
                this.ValueIndex["N - other Non-preferred species"] = 39;
                this.ValueIndex["A - Barnyards or Millets (Echinochloa spp)"] = 40;
                this.ValueIndex["A - Button Grass (Dactyloctenium radulans)"] = 41;
                this.ValueIndex["A - Chloris (Chloris (Small e.g. Windmill grass))"] = 42;
                this.ValueIndex["A - Fairy Grass (Sporobolus spp)"] = 43;
                this.ValueIndex["A - Finger Rush (Fimbristylis spp)"] = 44;
                this.ValueIndex["A - Fire Grass (Schizachrium)"] = 45;
                this.ValueIndex["A - Flinders Grass (Iseilema spp)"] = 46;
                this.ValueIndex["A - Forbs (Burrs, Chenopods, other non-grasses) (Forbs (Burrs, Chenopods, other non-grasses))"] = 47;
                this.ValueIndex["A - Native Couch (Brachyachne spp)"] = 48;
                this.ValueIndex["A - Panic (Panicum spp)"] = 49;
                this.ValueIndex["A - Small Burr Grass (Tragus australianus)"] = 50;
                this.ValueIndex["A - White Grass (Sehima spp)"] = 51;
                this.ValueIndex["A - Windmill grasses (Enteropogon spp)"] = 52;
                this.ValueIndex["A - other Annual or Forb"] = 53;
            }
        }
        static get Values() {
            this.initialise();
            return this.values;
        }
        static findByValue(value) {
            this.initialise();
            if (this.ValueIndex[value] != null) {
                return this.Values[this.ValueIndex[value]];
            }
            return null;
        }
        static findByKey(key) {
            this.initialise();
            if (this.KeyIndex[key] != null) {
                return this.Values[this.KeyIndex[key]];
            }
            return null;
        }
    }
    exports.MDpsDomain = MDpsDomain;
    Object.defineProperty(MDpsDomain, "PBlueGrassesEGForestBothriochloaSpp", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 1
    });
    Object.defineProperty(MDpsDomain, "PBlueGrassesEGQueenslandDichanthiumSpp", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 2
    });
    Object.defineProperty(MDpsDomain, "PBrowntopEulaliaSpp", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 3
    });
    Object.defineProperty(MDpsDomain, "PBuffelGrassCenchrusCiliaris", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 4
    });
    Object.defineProperty(MDpsDomain, "PChlorisSppLargeEGRhodesChlorisSppLargeEGRhodes", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 5
    });
    Object.defineProperty(MDpsDomain, "PMitchellGrassesAstreblaSpp", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 6
    });
    Object.defineProperty(MDpsDomain, "PMulgaMitchellThyridolepsisMitchelliana", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 7
    });
    Object.defineProperty(MDpsDomain, "PMulgaOatsMonochatherParadoxa", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 8
    });
    Object.defineProperty(MDpsDomain, "PNativeOatKangarooGrassThemedaSppExceptGraderGrass", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 9
    });
    Object.defineProperty(MDpsDomain, "PPanicPanicumSppLargeLeaf", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 10
    });
    Object.defineProperty(MDpsDomain, "PSabiGrassUrochloaSpp", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 11
    });
    Object.defineProperty(MDpsDomain, "PSpeargrassHeteropogonSpp", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 12
    });
    Object.defineProperty(MDpsDomain, "PSpinifexHardOrSoftTriodiaAndPlechtrachneSpp", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 13
    });
    Object.defineProperty(MDpsDomain, "POtherPreferredSpecies", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 14
    });
    Object.defineProperty(MDpsDomain, "IBarbwireGrassCymbopogonSpp", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 15
    });
    Object.defineProperty(MDpsDomain, "IBluebushMaireanaSpp", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 16
    });
    Object.defineProperty(MDpsDomain, "IBottleWashersEnneapogonSpp", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 17
    });
    Object.defineProperty(MDpsDomain, "ICaneGrassZygochloaParadoxa", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 18
    });
    Object.defineProperty(MDpsDomain, "IChlorisSmallEGWindmillGrassChlorisSmallEGWindmillGrass", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 19
    });
    Object.defineProperty(MDpsDomain, "ICouchCynodonDactylon", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 20
    });
    Object.defineProperty(MDpsDomain, "ICupgrassesEriochloaSpp", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 21
    });
    Object.defineProperty(MDpsDomain, "IFairyGrassSporobolusSpp", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 22
    });
    Object.defineProperty(MDpsDomain, "IFingerGrassesDigitariaSpp", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 23
    });
    Object.defineProperty(MDpsDomain, "IFiveMinuteGrassTripogonLoliiformis", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 24
    });
    Object.defineProperty(MDpsDomain, "IGoldenBeardGrassChrysopogonFallax", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 25
    });
    Object.defineProperty(MDpsDomain, "ILoveGrassesEragrostisSpp", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 26
    });
    Object.defineProperty(MDpsDomain, "IMolassesRedNatalMelinisSpp", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 27
    });
    Object.defineProperty(MDpsDomain, "IPanicPanicumSpp", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 28
    });
    Object.defineProperty(MDpsDomain, "ISaltBushesAtriplexSpp", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 29
    });
    Object.defineProperty(MDpsDomain, "ISorghumSorghumSpp", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 30
    });
    Object.defineProperty(MDpsDomain, "ISummerGrassPaspalidiumSpp", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 31
    });
    Object.defineProperty(MDpsDomain, "IWallabyGrassDanthoniaSpp", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 32
    });
    Object.defineProperty(MDpsDomain, "IWanderrieEriachneSpp", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 33
    });
    Object.defineProperty(MDpsDomain, "IOtherIntermediateSpecies", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 34
    });
    Object.defineProperty(MDpsDomain, "NBladyGrassImperataCylindrica", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 35
    });
    Object.defineProperty(MDpsDomain, "NNutGrassCyperusSpp", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 36
    });
    Object.defineProperty(MDpsDomain, "NReedGrassArundinellaSpp", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 37
    });
    Object.defineProperty(MDpsDomain, "NThatchGrassHyparrheniaSpp", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 38
    });
    Object.defineProperty(MDpsDomain, "NWiregrassesAristidaSpp", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 39
    });
    Object.defineProperty(MDpsDomain, "NOtherNonPreferredSpecies", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 40
    });
    Object.defineProperty(MDpsDomain, "ABarnyardsOrMilletsEchinochloaSpp", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 41
    });
    Object.defineProperty(MDpsDomain, "AButtonGrassDactylocteniumRadulans", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 42
    });
    Object.defineProperty(MDpsDomain, "AChlorisChlorisSmallEGWindmillGrass", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 43
    });
    Object.defineProperty(MDpsDomain, "AFairyGrassSporobolusSpp", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 44
    });
    Object.defineProperty(MDpsDomain, "AFingerRushFimbristylisSpp", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 45
    });
    Object.defineProperty(MDpsDomain, "AFireGrassSchizachrium", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 46
    });
    Object.defineProperty(MDpsDomain, "AFlindersGrassIseilemaSpp", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 47
    });
    Object.defineProperty(MDpsDomain, "AForbsBurrsChenopodsOtherNonGrassesForbsBurrsChenopodsOtherNonGrasses", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 48
    });
    Object.defineProperty(MDpsDomain, "ANativeCouchBrachyachneSpp", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 49
    });
    Object.defineProperty(MDpsDomain, "APanicPanicumSpp", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 50
    });
    Object.defineProperty(MDpsDomain, "ASmallBurrGrassTragusAustralianus", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 51
    });
    Object.defineProperty(MDpsDomain, "AWhiteGrassSehimaSpp", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 52
    });
    Object.defineProperty(MDpsDomain, "AWindmillGrassesEnteropogonSpp", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 53
    });
    Object.defineProperty(MDpsDomain, "AOtherAnnualOrForb", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 54
    });
    Object.defineProperty(MDpsDomain, "isInitialised", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
});
